import { makeStyles } from '@material-ui/core';
import { createTheme, darken, lighten } from '@material-ui/core/styles';
import { StyleSheet } from '@react-pdf/renderer';

export const BorderColor = '#90e5fc';

export const InputWidth = { width: '80%' };

export const HalfInputWidth = { width: '50%' };

const defaultTheme = createTheme();

export const AppBarStyle = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: '#5CDB95',
    alignItems: 'center',
    justifyContent: 'center',
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
    alignItems: 'center',
    color: 'white',
  },
  name: {
    flexGrow: 1,
    color: '#05386b',
  },
}));
export const tableCellStyle = makeStyles(
  theme => {
    const getBackgroundColor = (color) =>
      theme.palette.type === 'dark' ? darken(color, 0.6) : lighten(color, 0.6);

    const getHoverBackgroundColor = (color) =>
      theme.palette.type === 'dark' ? darken(color, 0.5) : lighten(color, 0.5);

    return {
      root: {
        '& .super-app-theme--Debit': {
          backgroundColor: getBackgroundColor(theme.palette.info.main),
          '&:hover': {
            backgroundColor: getHoverBackgroundColor(theme.palette.info.main),
          },
        },
        '& .super-app-theme--Credit': {
          backgroundColor: getBackgroundColor(theme.palette.success.main),
          '&:hover': {
            backgroundColor: getHoverBackgroundColor(
              theme.palette.success.main,
            ),
          },
        },
      },
    };
  },
  { defaultTheme },
);

export const headerBarStyle = makeStyles(theme => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  margin: {
    margin: theme.spacing(1),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  textField: {
    width: '25ch',
  },
}));

export const TableStyle = StyleSheet.create({
  tableContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 12,
    marginBottom: 90,
    paddingLeft: 20,
    paddingRight: 20,
    borderWidth: 1,
    borderColor: '#bff0fd',
  },
  redRow: {
    flexDirection: 'row',
    borderBottomColor: '#bff0fd',
    borderBottomWidth: 1,
    alignItems: 'center',
    justifyContent: 'center',
    height: 14,

    fontSize: 8,
  },
  particulars: {
    width: '38%',
    textAlign: 'left',
    borderRightColor: BorderColor,
    borderRightWidth: 1,
    paddingLeft: 3,
    color: 'red',
  },
  balEmp: {
    width: '14%',
    textAlign: 'center',
    borderRightColor: BorderColor,
    borderRightWidth: 1,
    paddingRight: 3,
  },
  balEmpN: {
    width: '16%',
    textAlign: 'center',
    borderRightColor: BorderColor,
    borderRightWidth: 1,
    paddingRight: 3,
  },
  bal: {
    width: '14%',
    textAlign: 'right',
    borderRightColor: BorderColor,
    borderRightWidth: 1,
    paddingRight: 3,
    color: 'red',
  },
});

export const TableHeaderStyle = StyleSheet.create({
  container: {
    flexDirection: 'row',
    borderColor: 'black',
    backgroundColor: '#EDF5E1',
    borderWidth: 1,
    alignItems: 'center',
    height: 14,
    fontFamily: 'Helvetica-Bold',
    textAlign: 'center',
    fontStyle: 'bold',
    fontSize: 8,
    flexGrow: 1,
  },
  containerCash: {
    flexDirection: 'row',
    flexGrow: 1,
    borderColor: 'black',
    borderWidth: 1,
    alignItems: 'center',
    height: 14,
    textAlign: 'center',
    fontStyle: 'bold',
    fontSize: 8,
  },
  ledger: {
    width: '8%',
    borderColor: 'black',
    fontFamily: 'Helvetica-Bold',
    borderRightWidth: 1,
  },
  voucher: {
    width: '12%',
    borderColor: 'black',
    fontFamily: 'Helvetica-Bold',
    borderRightWidth: 1,
  },
  trial: {
    width: '20%',
    borderColor: 'black',
    fontFamily: 'Helvetica-Bold',
    borderRightWidth: 1,
  },
  trialparticulars: {
    width: '50%',
    borderColor: 'black',
    fontFamily: 'Helvetica-Bold',
    borderRightWidth: 1,
  },
  trialcredit: {
    width: '15%',
    borderColor: 'black',
    fontFamily: 'Helvetica-Bold',
    borderRightWidth: 1,
  },
  trialcreditCash: {
    width: '50%',
    borderColor: 'black',
    fontFamily: 'Helvetica-Bold',
    borderRightWidth: 1,
    textAlign: 'left',
    paddingLeft: 9,
  },
  cashBookData: {
    width: '50%',
    borderColor: 'black',
    borderRightWidth: 1,
  },

  date: {
    width: '12%',
    borderColor: 'black',
    fontFamily: 'Helvetica-Bold',
    borderRightWidth: 1,
  },
  type: {
    width: '8%',
    borderColor: 'black',
    fontFamily: 'Helvetica-Bold',
    borderRightWidth: 1,
  },
  particulars: {
    width: '38%',
    borderColor: 'black',
    fontFamily: 'Helvetica-Bold',
    borderRightWidth: 1,
    paddingLeft: 3,
  },
  bal: {
    width: '14%',
    borderColor: 'black',
    fontFamily: 'Helvetica-Bold',
    borderRightWidth: 1,
  },
  ledgercheck: {
    width: '16%',
    borderColor: 'black',
    fontFamily: 'Helvetica-Bold',
    borderRightWidth: 1,
  },
  credit: {
    width: '14%',
    borderColor: 'black',
    fontFamily: 'Helvetica-Bold',
    borderRightWidth: 1,
  },
});

export const TableTitleStyle = StyleSheet.create({
  timeDate: {
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
  },
  titleContainer: {
    marginTop: 16,
    marginBottom: 8,
    paddingLeft: 60,
    paddingRight: 60,
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
  },
  headingContainer: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  rightContainer: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  reportHeading: {
    letterSpacing: 1,
    fontSize: 16,
    textAlign: 'center',
  },
  reportTitle: {
    fontFamily: 'Helvetica-Bold',
    textDecorationLine: 'underline',
    letterSpacing: 1,
    fontSize: 14,
    textAlign: 'center',
  },
  reportsubTitle: {
    fontSize: 12,
    textAlign: 'center',
    fontWeight: 'bold',
    textColor: 'blue',
    color: 'blue',
  },
  reportRightTitle: {
    fontSize: 6,
    textAlign: 'center',
  },
  reportLeftTitle: {
    fontSize: 8,
    textAlign: 'center',
  },
  reportRightSubTitle: {
    fontSize: 6,
    textAlign: 'center',
  },
  subContainerLedger: {
    marginLeft: 10,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  subContainer: {
    marginLeft: 10,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  subheader: {
    marginLeft: 10,
    marginRight: 100,
    letterSpacing: 1,
    fontSize: 10,
    textAlign: 'center',
  },
  date: {
    color: 'blue',
    fontSize: 9,
    textAlign: 'center',
  },
  codeDetails: {
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    marginTop: 5,
    flexDirection: 'row',
  },
  level2: {
    fontSize: 9,
    color: 'blue',
    textDecorationLine: 'underline',
  },
  level3: {
    fontSize: 9,
  },
  invoiceDate: {
    alignSelf: 'flex-end',
    fontSize: 6,
  },
});

export const TableRowStyle = StyleSheet.create({
  row: {
    flexDirection: 'row',
    borderBottomColor: '#bff0fd',
    borderBottomWidth: 1,
    alignItems: 'center',
    justifyContent: 'center',
    height: 14,
    fontSize: 8,
  },
  voucher: {
    textAlign: 'center',
    width: '8%',
    borderRightColor: BorderColor,
    borderRightWidth: 1,
  },
  date: {
    width: '12%',
    textAlign: 'center',
    borderRightColor: BorderColor,
    borderRightWidth: 1,
  },
  type: {
    width: '8%',
    textAlign: 'center',
    borderRightColor: BorderColor,
    borderRightWidth: 1,
  },
  particulars: {
    width: '38%',
    textAlign: 'center',
    borderRightColor: BorderColor,
    borderRightWidth: 1,
    paddingLeft: 3,
  },
  bal: {
    width: '14%',
    textAlign: 'right',
    borderRightColor: BorderColor,
    borderRightWidth: 1,
  },
  cheque: {
    width: '16%',
    textAlign: 'center',
    borderRightColor: BorderColor,
    borderRightWidth: 1,
  },
  trial: {
    width: '20%',
    borderRightColor: BorderColor,
    borderRightWidth: 1,
    paddingLeft: 8,
  },
  trialparticulars: {
    width: '50%',
    borderRightColor: BorderColor,
    borderRightWidth: 1,
    textAlign: 'left',
    paddingLeft: 3,
  },
  trialparticularslevel1: {
    width: '40%',
    borderRightColor: BorderColor,
    borderRightWidth: 1,
    textAlign: 'left',
    paddingLeft: 3,
  },
  trialtotallevel1: {
    width: '10%',
    borderRightColor: BorderColor,
    borderRightWidth: 1,
    textAlign: 'left',
    paddingLeft: 3,
  },

  trialtotallevel2: {
    width: '10%',
    borderRightColor: BorderColor,
    borderRightWidth: 1,
    textAlign: 'right',
    paddingRight: 3,
  },
  trialcredit: {
    width: '15%',
    borderRightColor: BorderColor,
    borderRightWidth: 1,
    textAlign: 'right',
    paddingRight: 3,
  },
  credit: {
    width: '14%',
    textAlign: 'right',
    borderRightColor: BorderColor,
    borderRightWidth: 1,
    paddingRight: 3,
  },
  invoiceRowCssLevel1: {
    flexDirection: 'row',
    color: 'red',
    borderColor: 'red',
    borderWidth: 1,
    alignItems: 'center',
    justifyContent: 'center',
    height: 14,
    marginBottom: 18,
    fontSize: 8,
  },
  invoiceRowCssLevel2: {
    flexDirection: 'row',
    color: 'blue',
    borderColor: 'blue',
    borderWidth: 1,
    alignItems: 'center',
    justifyContent: 'center',
    height: 14,
    marginBottom: 4,
    marginTop: 2,
    fontSize: 8,
  },
  invoiceRowCss: {
    flexDirection: 'row',
    borderColor: 'black',
    borderBottomWidth: 1,
    marginBottom: 2,
    alignItems: 'center',
    justifyContent: 'center',
    height: 14,
    fontSize: 8,
  },
  trialLevel3: {
    width: '20%',
    borderRightColor: BorderColor,
    borderRightWidth: 1,
    paddingLeft: 32,
  },
  trialLevel2: {
    width: '20%',
    borderRightColor: BorderColor,
    borderRightWidth: 1,
    paddingLeft: 20,
  },
  container: {
    flexDirection: 'row',
    borderColor: 'black',
    backgroundColor: '#EDF5E1',
    borderWidth: 1,
    alignItems: 'center',
    height: 28,
    fontFamily: 'Helvetica-Bold',
    textAlign: 'center',
    fontStyle: 'bold',
    fontSize: 8,
    flexGrow: 1,
  },
  cashBookRec: {
    width: '25%',
    borderColor: 'black',
    borderRightWidth: 1,
    alignItems: 'center',
  },
  cashBookPar: {
    width: '20%',
    borderColor: 'black',
    borderRightWidth: 1,
    paddingLeft: 3,
  },
  cashBookColSmall: {
    width: '7%',
    textAlign: 'center',
    borderColor: 'black',
    borderRightWidth: 1,
  },
  cashBookColCode: {
    width: '10%',
    textAlign: 'center',
    borderColor: 'black',
    borderRightWidth: 1,
  },
  cashBookColSub: {
    width: '33%',
    textAlign: 'center',
    borderColor: 'black',
    borderRightWidth: 1,
  },
});

export const TableFooterStyle = StyleSheet.create({
  description: {
    width: '40%',
    textAlign: 'right',
    borderRightColor: BorderColor,
    borderRightWidth: 1,
    paddingRight: 8,
  },

  bottomSpace: {
    width: '40%',
    textAlign: 'right',
    borderRightColor: BorderColor,
    borderRightWidth: 1,
    paddingRight: 8,
  },
  totalBottom: {
    width: '15%',
    textAlign: 'right',
    borderRightColor: BorderColor,
    borderRightWidth: 1,
    paddingLeft: 8,
    color: 'blue',
    paddingRight: 3,
  },
  total: {
    width: '15%',
    textAlign: 'right',
    borderRightColor: BorderColor,
    borderRightWidth: 1,
    paddingLeft: 8,
    paddingRight: 3,
  },
  totalVocuher: {
    width: '15%',
    textAlign: 'right',

    paddingLeft: 8,
  },
  footerVoucherCss: {
    flexDirection: 'row',
    marginTop: 9,
    alignItems: 'center',
    height: 24,
    fontSize: 9,
    fontFamily: 'Helvetica-Bold',
    fontStyle: 'bold',
  },
  voucherFooterAmountinText: {
    width: '35%',
    fontFamily: 'Helvetica-Bold',
    textAlign: 'left',
    paddingLeft: 8,
    borderBottomWidth: 1,
  },
  voucherFooterSignatureText: {
    width: '20%',
    fontFamily: 'Helvetica-Bold',
    textAlign: 'left',

    paddingLeft: 8,
  },

  voucherdescription: {
    width: '40%',
    textAlign: 'right',

    paddingRight: 8,
  },
  footerVoucherSignatureArea: {
    flexDirection: 'row',
    marginTop: 40,
    height: 24,

    fontSize: 9,
    alignItems: 'center',
    justifyContent: 'space-evenly',
    fontFamily: 'Helvetica-Bold',
    fontStyle: 'bold',
  },

  cashBookRec: {
    width: '25%',
    borderColor: 'black',
    alignItems: 'center',
  },
  cashBookPar: {
    width: '20%',
    borderColor: 'black',
    fontFamily: 'Helvetica-Bold',
    borderRightWidth: 1,
  },
  cashBookColSmall: {
    width: '7%',
    borderColor: 'black',
    borderRightWidth: 1,
  },
  cashBookColCode: {
    width: '10%',
    textAlign: 'center',
    borderColor: 'black',
    borderRightWidth: 1,
  },
  cashBookColSub: {
    width: '33%',
    borderColor: 'black',
    textAlign: 'center',
    borderRightWidth: 1,
  },
});
